module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_woowahan_m2.dfb33e3e67659e15dd866b7cfb239490.png";